import { Tooltip as MuiTooltip, TooltipProps } from '@material-ui/core';

const Tooltip = (props: TooltipProps) => {
  return <MuiTooltip enterTouchDelay={0} leaveTouchDelay={2000} className="mobileCtrlTooltip" {...props} />;
};

export default Tooltip;
